module.exports = __webpack_public_path__ + "static/media/sketch.52feedcf.png";